import { getSupplier } from '@bridebook/web/app-basic/lib/supplier/selectors';
import { useSelector } from '@bridebook/web/app-basic/lib/utils';
import AboutMeComp, {
  IProps as IAboutMeProps,
} from '@bridebook/web/app-basic/components/supplier/sections/about-me/about-me';

const AboutMe = () => {
  const supplier = useSelector(getSupplier);

  const props: IAboutMeProps = {
    supplier,
  };

  return <AboutMeComp {...props} />;
};

export default AboutMe;
